"use client";
import { useEffect, useState } from "react";
import {
  NextButton,
  PrevButton,
} from "../../../../../components/new_components/buttonsFlow";
import { BottomSheet } from "../../../../../components/new_components/BottomSheet";
import { ReactComponent as GalileIcon } from "../../../../../public/logos/galilea-icono.svg";
import AnimationComponent from "../../../../../components/new_components/animation";
import { useWindowSize } from "../../../helpers/bankDimensions";
import { stepsCreditStore } from "../../../../../store/creditStore/stepsCreditStore";
import { variablesGlobales } from "../../../../../configs/variables";
import axios from "axios";
import { normalizeMessage } from "../cardComponents/normalizeMessage";
import { useAlert } from "../provider/alertProvider";
import { hasToken } from "../cardComponents/utils";

const AutoAdvance = ({ onNext, delay }) => {
  useEffect(() => {
    const t = setTimeout(onNext, delay);
    return () => clearTimeout(t);
  }, [onNext, delay]);
  return null;
};

const Step1 = ({ onNext, onBack, isDesktop }) => {
  const [dialogOpenBancolombia, setDialogOpenBancolombia] = useState(false);

  const { width, height } = useWindowSize();

  const isMedium = isDesktop && width < 1600;

  const heightContainer =
    height < 700 ? "46dvh" : height <= 840 ? "65dvh" : "68dvh";

  const handleToggleDialogBancolombia = () => {
    if (dialogOpenBancolombia) {
      setDialogOpenBancolombia(false);
    } else {
      setDialogOpenBancolombia(true);
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: isDesktop ? "-webkit-fill-available" : heightContainer,
        gap: isDesktop ? "24px" : "12px",
        padding: isDesktop ? "0 40px" : "0",
        width: "100%",
      }}
    >
      {/* Bloque superior */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isDesktop ? (isMedium ? "8px" : "80px") : "25px",
          flex: 1, // ← ocupa todo el espacio disponible
        }}
        className="p-4"
      >
        {/* Título */}
        {isDesktop ? (
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              <span
                style={{
                  fontSize: isDesktop ? "clamp(28px, 4vw, 40px)" : "26px",
                  fontWeight: 800,
                  color: "#fff",
                }}
              >
                Conexión con
              </span>
              <img
                src="/png/bancolombia-completo-blanco.png"
                alt="Bancolombia"
                style={{
                  maxWidth: "none",
                  height: "75px",
                  width: "250px",
                }}
              />
            </div>
            <p style={{ color: "#9b93b8", fontSize: "14px", marginTop: "4px" }}>
              Serás redirigido al portal seguro de Bancolombia.
            </p>
          </div>
        ) : (
          <div className="flex justify-center">
            {" "}
            <img
              src="/png/bancolombia-completo-blanco.png"
              alt="Bancolombia"
              style={{
                maxWidth: "none",
                height: "75px",
                width: "250px",
              }}
            />
          </div>
        )}

        {/* Resumen */}
        <div
          style={{
            background: "#565584",
            borderRadius: "14px",
            padding: isDesktop ? "20px 24px" : "14px 16px",
            display: "flex",
            flexDirection: "column",
            gap: isDesktop ? "14px" : "10px",
          }}
        >
          <span style={{ fontWeight: 700, color: "#E1DFE5", fontSize: "15px" }}>
            Resumen de conexión
          </span>
          {[
            "Serás redirigido al portal oficial de Bancolombia.",
            "Seleccionarás la cuenta que deseas conectar.",
            "Paga tu crédito de forma más rápida y segura.",
            "Al finalizar, volverás aquí para continuar con tu crédito.",
          ].map((text, i) => (
            <div
              key={i}
              style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}
            >
              {/* Check activo no manipulable */}
              <div
                style={{
                  minWidth: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  background: "rgb(41 33 79)",
                  flexShrink: 0,
                  marginTop: "2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path
                    d="M2 5l2.5 2.5L8 3"
                    stroke="#fff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span
                style={{
                  color: "white",
                  fontSize: isDesktop ? "14px" : "13px",
                  lineHeight: "1.4",
                }}
              >
                {text}
              </span>
            </div>
          ))}
        </div>

        {/* Toast seguridad */}
        <div
          className="bg-purple"
          style={{
            borderRadius: "12px",
            padding: "12px 16px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <div
            style={{
              flexShrink: 0,
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "#2a2550",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <rect
                x="5"
                y="11"
                width="14"
                height="10"
                rx="2"
                stroke="white"
                strokeWidth="1.8"
              />
              <path
                d="M8 11V7a4 4 0 1 1 8 0v4"
                stroke="white"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
              <circle cx="12" cy="16" r="1.5" fill="white" />
            </svg>
          </div>
          <p style={{ fontSize: "14px", margin: 0 }}>
            <span style={{ color: "white" }}>Tus credenciales </span>
            <span style={{ color: "white", fontWeight: 700 }}>
              nunca pasan{" "}
            </span>
            <span style={{ color: "white" }}>
              por nosotros. Todo es directamente con tu entidad bancaria.
            </span>
          </p>
        </div>
      </div>

      {/* Botones — siempre al fondo */}
      <div
        className="w-full gap-4"
        style={{
          display: "flex",
          justifyContent: isDesktop ? "flex-end" : "stretch",
        }}
      >
        <div
          style={{
            width: isDesktop ? "400px" : "-webkit-fill-available",
            display: "flex",
            justifyContent: isDesktop && "center",
          }}
        >
          <PrevButton onBack={onBack} label={"Atrás"} isMobile={!isDesktop} />
          <NextButton
            onNext={handleToggleDialogBancolombia}
            label={"Continuar"}
            isMobile={!isDesktop} // ← solo aquí
          />
        </div>
      </div>

      <BottomSheet
        open={dialogOpenBancolombia}
        onOpenChange={setDialogOpenBancolombia}
        isDesktop={isDesktop}
        footerContent={
          <div className="flex gap-5 h-16">
            <PrevButton
              onBack={() => {
                handleToggleDialogBancolombia();
              }}
              label={"Atrás"}
            />
            <NextButton
              onNext={(e) => {
                handleToggleDialogBancolombia();
                setTimeout(() => {
                  onNext();
                }, 700);
              }}
              label={"Continuar"}
            />
          </div>
        }
      >
        <div
          className="flex flex-col items-center justify-evenly space-y-3 w-full h-full"
          style={{
            gap: !isDesktop && "20px",
          }}
        >
          <div className="w-[350px] flex flex-col items-center justify-center text-center pt-5">
            <p className="text-white text-lg font-bold2 mb-2">
              Te llevaremos al portal ofical de Bancolombia para conectar tu
              cuenta, Galilea nunca verá tus claves ni tus datos bancarios
            </p>
          </div>

          <div className="flex flex-col justify-around gap-7 items-center">
            <img
              src="/png/bancolombia-completo-blanco.png"
              alt="Bancolombia"
              style={{
                maxWidth: "none",
                height: "75px",
                width: "250px",
              }}
            />
          </div>
          <div className="w-[350px] flex flex-col items-center justify-center text-center px-4 py-6 rounded-xl bg-metal">
            <p className="text-white text-sm mb-2">
              Tus credenciales nunca pasan por nosotros, Tus datos siempre estan
              seguros
            </p>
          </div>
        </div>
      </BottomSheet>
    </div>
  );
};

// const Step2 = ({ onNext, onBack, isDesktop, urlBancolombia }) => {
//   const { width, height } = useWindowSize();

//   const isMedium = isDesktop && width < 1200;
//   const isSmallLaptop = isDesktop && height < 750;

//   const heightContainer =
//     height < 700 ? "46dvh" : height <= 840 ? "65dvh" : "68dvh";

//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "space-between",
//         minHeight: isDesktop ? "-webkit-fill-available" : heightContainer,
//         padding: isDesktop ? "0 80px" : "0",
//         width: "100%",
//         gap: "10px",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           gap: isDesktop ? "20px" : "14px",
//           flex: 1,
//         }}
//       >
//         {/* Título */}
//         <div>
//           <h2
//             style={{
//               fontSize: isDesktop ? "clamp(28px, 4vw, 40px)" : "22px",
//               fontWeight: 800,
//               color: "#fff",
//               marginBottom: "4px",
//             }}
//           >
//             Ir a Bancolombia
//           </h2>
//           <p
//             style={{
//               color: "#9b93b8",
//               fontSize: isDesktop ? "14px" : "12px",
//               lineHeight: "1.4",
//               margin: 0,
//             }}
//           >
//             Al dar clic en el botón serás redirigido al portal seguro de
//             Bancolombia para autorizar la conexión.
//           </p>
//         </div>

//         <div
//           style={{
//             background: "#565584",
//             borderRadius: "14px",
//             padding: isDesktop ? "20px 24px" : "14px 16px",
//             display: "flex",
//             flexDirection: "column",
//             gap: isDesktop ? "14px" : "10px",
//           }}
//         >
//           <span style={{ fontWeight: 700, color: "#E1DFE5", fontSize: "15px" }}>
//             Resumen de conexión
//           </span>
//           {[
//             "Saldrás de la app temporalmente para conectar con Bancolombia.",
//             "Tus claves nunca pasan por nosotros. Todo es directo con Bancolombia.",
//             "Cuando termines en Bancolombia, vuelve aquí para continuar.",
//           ].map((text, i) => (
//             <div
//               key={i}
//               style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}
//             >
//               {/* Check activo no manipulable */}
//               <div
//                 style={{
//                   minWidth: "18px",
//                   height: "18px",
//                   borderRadius: "50%",
//                   background: "rgb(41 33 79)",
//                   flexShrink: 0,
//                   marginTop: "2px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
//                   <path
//                     d="M2 5l2.5 2.5L8 3"
//                     stroke="#fff"
//                     strokeWidth="1.5"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </div>
//               <span
//                 style={{
//                   color: "white",
//                   fontSize: isDesktop ? "14px" : "13px",
//                   lineHeight: "1.4",
//                 }}
//               >
//                 {text}
//               </span>
//             </div>
//           ))}
//         </div>
//         {/* Avisos antes de salir */}
//       </div>

//       {/* Botón Bancolombia + Atrás */}
//       <div
//         style={{
//           display: "flex",
//           gap: "10px",
//           justifyContent: isDesktop && "flex-end",
//         }}
//       >
//         {/* Botón principal Bancolombia */}

//         {/* Botón atrás */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: isDesktop ? "flex-end" : "center",
//           }}
//         >
//           <PrevButton onBack={onBack} label="Atrás" isMobile={!isDesktop} />
//         </div>
//         <NextButton
//           onNext={onNext}
//           label={"Ir a Bancolombia"}
//           isMobile={!isDesktop}
//           showIconNext={true}
//           disabled={!urlBancolombia}
//         >
//           <ExternalLinkOutline className="w-6 h-6" style={{ color: "black" }} />
//         </NextButton>
//         {/* <button
//           type="button"
//           onClick={onNext}
//           style={{
//             width: isDesktop ? "500px" : "100%",
//             height: isDesktop ? "56px" : "70px",
//             borderRadius: "2.5rem",
//             background: urlBancolombia // ← visual feedback si no hay URL
//               ? "linear-gradient(135deg, #FDDA24 0%, #f0c800 100%)"
//               : "#4a4770",
//             border: "none",
//             cursor: urlBancolombia ? "pointer" : "not-allowed",
//             opacity: urlBancolombia ? 1 : 0.6,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "12px",
//             transition: "opacity 0.2s",
//           }}
//           onMouseEnter={(e) =>
//             urlBancolombia && (e.currentTarget.style.opacity = "0.9")
//           }
//           onMouseLeave={(e) =>
//             urlBancolombia && (e.currentTarget.style.opacity = "1")
//           }
//         >
//           <span
//             style={{
//               color: "#1a1a1a",
//               fontWeight: 800,
//               fontSize: isDesktop ? "16px" : "18px",
//               letterSpacing: "0.3px",
//             }}
//           ></span>
//         </button> */}
//       </div>
//     </div>
//   );
// };

const Step2 = ({ onNext, onBack, isDesktop, urlBancolombia }) => {
  const { width, height } = useWindowSize();

  const isMedium = isDesktop && width < 1600;

  const heightContainer =
    height < 700 ? "46dvh" : height <= 840 ? "65dvh" : "68dvh";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: isDesktop ? "-webkit-fill-available" : heightContainer,
        padding: isDesktop ? "0 80px" : "0",
        width: "100%",
        gap: "10px",
      }}
    >
      {/* Bloque superior */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isDesktop ? (isMedium ? "15px" : "70px") : "25px",
          flex: 1,
        }}
        className="p-4"
      >
        {/* Título */}
        <div>
          <h2
            style={{
              fontSize: isDesktop ? "clamp(28px, 4vw, 40px)" : "22px",
              fontWeight: 800,
              color: "#fff",
              marginBottom: "4px",
            }}
          >
            Todo listo para conectar
          </h2>
          <p
            style={{
              color: "#9b93b8",
              fontSize: isDesktop ? "14px" : "12px",
              lineHeight: "1.4",
              margin: 0,
            }}
          >
            Al continuar, autorizas la conexión entre tu banco y Galilea. No
            almacenaremos tus claves ni datos sensibles.
          </p>
        </div>

        {/* Card banco seleccionado */}
        <div className="flex flex-col items-center">
          <div
            style={{
              background: isDesktop ? "rgb(26 24 48)" : "rgb(41, 33, 79)",
              borderRadius: "14px",
              padding: isDesktop ? "20px 24px" : "12px 16px",
              display: "flex",
              flexDirection: "column",
              gap: isDesktop ? "5px" : "8px",
              width: isDesktop && "500px",
              justifyContent: isDesktop && "space-around",
            }}
          >
            <span
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "#9b93b8",
                letterSpacing: "1.5px",
              }}
            >
              BANCO SELECCIONADO
            </span>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div>
                {/* <p
                  style={{
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: isDesktop ? "18px" : "15px",
                    margin: "0 0 2px",
                  }}
                > */}
                  <img
                    src="/png/bancolombia-completo-blanco.png"
                    alt="Bancolombia"
                    style={{
                      maxWidth: "none",
                      height: isDesktop ? (isMedium ? "65px" : "70px") : "60px",
                      width: isDesktop
                        ? isMedium
                          ? "200px"
                          : "230px"
                        : "180px",
                    }}
                  />
                {/* </p> */}
              </div>
            </div>
            <div
              style={{
                background: "#3d3870",
                borderRadius: "8px",
                padding: "8px 12px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <div
                style={{
                  minWidth: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  background: "rgb(41 33 79)",
                  flexShrink: 0,
                  marginTop: "2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path
                    d="M2 5l2.5 2.5L8 3"
                    stroke="#fff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span
                style={{
                  color: "#C9B8FF",
                  fontSize: isDesktop ? "13px" : "12px",
                }}
              >
                Tus pagos se procesarán de forma segura.
              </span>
            </div>
          </div>
        </div>

        {/* Banner seguridad */}
        <div
          className="bg-purple"
          style={{
            borderRadius: "12px",
            padding: "12px 16px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <div
            style={{
              flexShrink: 0,
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "#2a2550",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <rect
                x="5"
                y="11"
                width="14"
                height="10"
                rx="2"
                stroke="white"
                strokeWidth="1.8"
              />
              <path
                d="M8 11V7a4 4 0 1 1 8 0v4"
                stroke="white"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
              <circle cx="12" cy="16" r="1.5" fill="white" />
            </svg>
          </div>
          <p style={{ fontSize: "14px", margin: 0 }}>
            <span style={{ color: "white" }}>Tus credenciales </span>
            <span style={{ color: "white", fontWeight: 700 }}>
              nunca pasan{" "}
            </span>
            <span style={{ color: "white" }}>
              por nosotros. Todo es directamente con tu entidad bancaria.
            </span>
          </p>
        </div>
      </div>

      {/* Botones — siempre al fondo */}

      <div
        className="w-full gap-4"
        style={{
          display: "flex",
          justifyContent: isDesktop ? "flex-end" : "stretch",
        }}
      >
        <div
          style={{
            width: isDesktop ? "400px" : "-webkit-fill-available",
            display: "flex",
            justifyContent: isDesktop && "center",
          }}
        >
          <PrevButton onBack={onBack} label={"Atrás"} isMobile={!isDesktop} />
          <NextButton
            onNext={onNext}
            label={"Ir a "}
            logo={
              <img
                src="/png/bancolombia-completo-blanco.png"
                alt="Bancolombia"
                style={{
                  maxWidth: "none",
                  height: isDesktop ? (isMedium ? "40px" : "40px") : "35px",
                  width: isDesktop ? (isMedium ? "110px" : "120px") : "100px",
                }}
              />
            }
            isMobile={!isDesktop}
            showIconNext={true}
            isBancolombiaIcon={true}
            disabled={!urlBancolombia}
          ></NextButton>
        </div>
      </div>
    </div>
  );
};

const Step3 = ({ onNext, isDesktop }) => {
  const { width } = useWindowSize();

  const isMedium = isDesktop && width > 1600;
  return (
    <div
      className="flex flex-col w-full items-center"
      style={{
        paddingTop: "20px",
        paddingLeft: isDesktop ? "clamp(60px, 7vw, 80px)" : "0",
        paddingRight: isDesktop ? "clamp(60px, 7vw, 80px)" : "0",
        gap: isDesktop ? (isMedium ? "120px" : "80px") : "70px",
      }}
    >
      <style>{`
      @keyframes bounce {
        0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
        40% { transform: translateY(-10px); opacity: 1; }
      }
      @keyframes spin { to { transform: rotate(360deg); } }
    `}</style>

      <h2
        style={{
          color: "#fff",
          fontWeight: 800,
          fontSize: "clamp(20px, 3vw, 28px)",
          textAlign: "center",
          alignSelf: "flex-start",
        }}
      >
        Estamos conectando tu cuenta de Bancolombia, por favor no cierres esta pagina.
      </h2>

      {/* Logos + dots */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
          margin: "8px 0",
        }}
      >
        {/* Logo Galilea */}
        <GalileIcon
          style={{
            width: isDesktop ? (isMedium ? "180px" : "100px") : "60px",
            height: isDesktop ? (isMedium ? "110px" : "100px") : "60px",
          }}
          alt="Galilea"
        />

        {/* Dots animados */}
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                width: isDesktop ? "18px" : "14px",
                height: isDesktop ? "18px" : "14px",
                borderRadius: "50%",
                backgroundColor: "white",
                animation: `bounce 1.2s ease-in-out ${i * 0.15}s infinite`,
                display: "flex",
                gap: "30px",
              }}
            />
          ))}
        </div>
        <img
          src="/png/bancolombia-completo-blanco.png"
          alt="Bancolombia"
          style={{
            maxWidth: "none",
            height: isDesktop ? (isMedium ? "100px" : "100px") : "80px",
            width: isDesktop ? (isMedium ? "250px" : "200px") : "170px",
          }}
        />
      </div>

      {/* Card con checks */}
      <div
        style={{
          background: "#565584",
          borderRadius: "14px",
          padding: isDesktop ? "20px 24px" : "14px 16px",
          display: "flex",
          flexDirection: "column",
          gap: isDesktop ? "14px" : "10px",
        }}
      >
        {[
          "Seleccionarás la cuenta que deseas conectar.",
          "Paga tu crédito de forma más rápida y segura.",
          "Tus pagos se procesarán de forma segura.",
        ].map((text, i) => (
          <div
            key={i}
            style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}
          >
            {/* Check activo no manipulable */}
            <div
              style={{
                minWidth: "18px",
                height: "18px",
                borderRadius: "50%",
                background: "rgb(41 33 79)",
                flexShrink: 0,
                marginTop: "2px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path
                  d="M2 5l2.5 2.5L8 3"
                  stroke="#fff"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <span
              style={{
                color: "white",
                fontSize: isDesktop ? "14px" : "13px",
                lineHeight: "1.4",
              }}
            >
              {text}
            </span>
          </div>
        ))}
      </div>
      {/* <AutoAdvance onNext={onNext} delay={3000} /> */}
    </div>
  );
};

const Step5 = ({ isDesktop, onComplete }) => {
  const { height } = useWindowSize();

  let heightCanvan = height < 750 ? "17rem" : height > 900 ? "25rem" : "20rem";
  let widthCanvan = height < 750 ? "15rem" : height > 900 ? "23rem" : "20rem";

  let heightContainer =
    height < 750 ? "19rem" : height > 900 ? "30rem" : "20rem";
  return (
    <div className="flex flex-col items-center justify-center">
      {/* Componente de animación Rive */}
      <h1
        className="font-bold2"
        style={{
          fontSize: "2rem",
          width: "300px",
          textAlign: "center",
        }}
      >
        ¡Luz Púrpura para Continuar!
      </h1>
      <AnimationComponent
        animationUrl="/animations/checkanimation.riv"
        width={heightCanvan}
        height={widthCanvan}
        heightContainer={heightContainer}
        isDesktop={isDesktop}
        stateMachines={["chek-animation"]}
      />
      <p
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "200px",
        }}
      >
        <span>
          ¡<span style={{ color: "#A68AFF" }}>Felicitaciones</span>!
        </span>
        <span
          style={{
            textAlign: "center",
          }}
        >
          Conexión segura realizada.
        </span>
      </p>
      <p
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <span
          style={{
            textAlign: "center",
          }}
        >
          Nos hemos conectado a tu banco de manera exitosa.
        </span>
      </p>
      <AutoAdvance onNext={onComplete} delay={3000} />
    </div>
  );
};

// ── Orquestador Bancolombia ──
// ── Orquestador Bancolombia ──
const BancolombiaFlow = ({
  bankValue,
  onComplete,
  onBack,
  isDesktop,
}) => {
  const [step, setStep] = useState(1);
  const [, setTokenError] = useState(null);
  const [urlBancolombia, setUrlBancolombia] = useState(null);
  const [tokenIdWompi, setTokenIdWompi] = useState(null);
  const number_document = localStorage.getItem("doc");
  const customer_email = localStorage.getItem("email");
  const { stepCredit, saveSteps, loadSteps } = stepsCreditStore();
  const { showAlert } = useAlert();

  useEffect(() => {
    let tokenIdWompi = localStorage.getItem("tokenIdWompi");
    if (hasToken(tokenIdWompi)) setTokenIdWompi(tokenIdWompi);
  }, []);

  useEffect(() => {
    const transferState = localStorage.getItem("transferState");
    const transferCode = localStorage.getItem("transferCode");

    if (transferState === "rejected") {
      showAlert(
        "warning",
        "No se ha podido conectar con Bancolombia. Intenta nuevamente.",
        8000,
      );
      setStep(1);
      saveSteps({ ...stepCredit, stepFlow: 1 });

      // Limpiar los query params de la URL sin recargar la página
      window.history.replaceState({}, "", window.location.pathname);
    } else if (
      transferCode !== null &&
      transferCode !== undefined &&
      !tokenIdWompi
    ) {
      setTimeout(() => {
        handlePaymentMethod();
      }, 10000);
    }
    // Efecto de solo montaje: revisa el resultado de la redirección de
    // Bancolombia una única vez. handlePaymentMethod/showAlert dependen de
    // stepCredit/tokenIdWompi (y showAlert no es estable entre renders), así
    // que declararlos forzaría llamadas repetidas al endpoint de pagos. Se
    // deja deliberadamente fuera del arreglo de dependencias.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadSteps();
  }, [loadSteps]);

  useEffect(() => {
    if (!stepCredit?.stepFlow) return;
    setStep(stepCredit.stepFlow);
  }, [stepCredit]);

  const next = () => {
    const nextStep = step + 1;
    setStep(nextStep);
    saveSteps({ ...stepCredit, stepFlow: nextStep });
  };

  const onCompleteFlow = () => {
    saveSteps({ ...stepCredit, stepFlow: 1 });
    onComplete();
  };

  const prev = () => {
    if (step === 1) {
      onBack();
    } else {
      let prevStep = 1;
      if (step === 4) prevStep = step - 2;
      if (step === 2) prevStep = step - 1;
      setStep(prevStep);
      saveSteps({ ...stepCredit, stepFlow: prevStep });
    }
  };

  const handleTokenize = async () => {
    setTokenError(null);
      let payloadData = {
      redirect_url: `${window.location.origin}${window.location.pathname}`,
      customer_email,
      number_document,
    };

    let payload = {
      bankName: "bancolombia",
      dataTokenization: payloadData,
    };

    try {
      const tokenSession = localStorage.getItem("token_jwt");

      const res = await axios.post(
        `${variablesGlobales.urlServiceBackend}/api/v1/tokenization/createTokenization`,
        payload,
        {
          headers: {
            authorization: `Bearer ${tokenSession}`,
          },
        },
      );

      const data = res.data;

      if (data?.status === "PENDING") {
        if (data?.message) {
          showAlert("info", normalizeMessage(data.message), 6000);
        }
        setUrlBancolombia(data?.authorization_url);
        setTokenIdWompi(data?.id);
        localStorage.setItem("tokenIdWompiSend", data?.id);
        setStep(2);
        saveSteps({ ...stepCredit, stepFlow: 2 });
      } else {
        showAlert(
          "warning",
          data?.message || "Error al conectar tu cuenta bancolombia",
          8000,
        );
        setTimeout(() => {
          setStep(1);
          saveSteps({ ...stepCredit, stepFlow: 1 });
        }, 5000);
      }
    } catch (err) {
      console.error("Error de red:", err);
      setTokenError("Error de conexión. Intenta nuevamente.");
      setTimeout(() => {
        setStep(1);
        saveSteps({ ...stepCredit, stepFlow: 1 });
      }, 5000);
    }
  };

  const handleGoBancolombia = () => {
    setStep(3);
    saveSteps({ ...stepCredit, stepFlow: 3 });
    window.location.href = urlBancolombia;
  };

  const handlePaymentMethod = async () => {
    setTokenError(null);

    // ← Explícito, no depende del closure de next()
    let tokenIdWompiSend = localStorage.getItem("tokenIdWompiSend");
    let payloadData = {
      id: tokenIdWompiSend,
    };

    let payload = {
      bankName: "bancolombia",
      dataTokenization: payloadData,
    };

    try {
      const tokenSession = localStorage.getItem("token_jwt");

      const res = await axios.post(
        `${variablesGlobales.urlServiceBackend}/api/v1/tokenization/status`,
        payload,
        {
          headers: {
            authorization: `Bearer ${tokenSession}`,
          },
        },
      );

      const data = res.data;

      if (data?.status === "AVAILABLE") {
        showAlert("info", normalizeMessage(data?.message), 6000);
        localStorage.setItem("tokenIdWompi", data?.token_data.id);
        setStep(4);
        saveSteps({ ...stepCredit, stepFlow: 4 });
      } else {
        showAlert(
          "warning",
          data?.message || "Error al conectar tu cuenta bancolombia",
          8000,
        );
        setTimeout(() => {
          setStep(1);
          saveSteps({ ...stepCredit, stepFlow: 1 });
        }, 5000);
      }
    } catch (err) {
      const errorMsg =
        err?.response?.data?.message ||
        "Error de conexión. Intenta nuevamente.";
      console.error("Wompi error:", err?.response?.data);
      showAlert("warning", errorMsg, 8000);
      setTokenError("Error de conexión. Intenta nuevamente.");
      setTimeout(() => {
        setStep(1);
        saveSteps({ ...stepCredit, stepFlow: 1 });
      }, 5000);
    }
  };

  // También pasa tokenIdWompi al Step4 y Step5 por si lo necesitas después
  switch (step) {
    case 1:
      return (
        <Step1
          onNext={handleTokenize}
          onBack={prev}
          isDesktop={isDesktop}
          bank={bankValue}
        />
      );
    case 2:
      return (
        <Step2
          onNext={handleGoBancolombia}
          onBack={prev}
          isDesktop={isDesktop}
          bank={bankValue}
          urlBancolombia={urlBancolombia}
        />
      );
    case 3:
      return <Step3 onNext={next} isDesktop={isDesktop} bank={bankValue} />;
    // case 4:
    //   return (
    //     <Step4
    //       onNext={handlePaymentMethod}
    //       onBack={prev}
    //       isDesktop={isDesktop}
    //       bank={bankValue}
    //       tokenId={tokenIdWompi}
    //     />
    //   );
    case 4:
      return (
        <Step5
          onComplete={onCompleteFlow}
          onBack={prev}
          isDesktop={isDesktop}
          bank={bankValue}
        />
      );
    default:
      return null;
  }
};

export default BancolombiaFlow;
